/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2BulletListIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2BulletListIcon({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2BulletListIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 14,
  height = 14,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2BulletListIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 14 14"
 style={{'--as-1-Zt3d8c': alignSelf,'--mt-2-Zt3d8c': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Zt3d8c': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Zt3d8c': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Zt3d8c': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Zt3d8c': opacity,'--w-10-Zt3d8c': typeof width === 'number' ? `${width}px` : width,'--h-11-Zt3d8c': typeof height === 'number' ? `${height}px` : height,'--f-12-Zt3d8c': fill,'--a-7-Zt3d8c': isAnimated ? animation : "none",'--sd-8-Zt3d8c': isAnimated ? strokeDashoffset : 0,'--sd-9-Zt3d8c': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2BulletListIcon.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M2 2.5a1 1 0 11-2 0 1 1 0 012 0zM1 8a1 1 0 100-2 1 1 0 000 2zm0 4.5a1 1 0 100-2 1 1 0 000 2zM4.75 1.75a.75.75 0 000 1.5h8.5a.75.75 0 000-1.5h-8.5zM4 7a.75.75 0 01.75-.75h8.5a.75.75 0 010 1.5h-8.5A.75.75 0 014 7zm.75 3.75a.75.75 0 000 1.5h8.5a.75.75 0 000-1.5h-8.5z"
 style={{'--f-12-Zt3d8c': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}